import * as Sentry from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import "./index.css"

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://50c8b5f2fbdf2f5c68917d0c84d2adc0@o4509482575331328.ingest.us.sentry.io/4509482688512000",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
